import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Col, FormLabel, Modal, Row } from "react-bootstrap";
import { EditCMS, addNewCMS } from "../actions/admin";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import toast from "react-hot-toast";
import { API_URL } from "../config";

const initialFormValue = {
  identifier: "",
  heading: "",
  subHeading: "",
  content: "",
  testimonial: []
};

const EditCmsModal = ({ show, handleClose, record, getCMSData }) => {
  console.log("🚀 ~ EditCmsModal ~ record:", record)
  const [count, setCount] = useState(1);


  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    setFormvalue(record);
    console.log(record?.testimonial?.length, 'record?.testimonial?.length')
    setCount(record?.testimonial?.length)
  }, [record]);

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let Formvalue = { ...formvalue, [name]: value };
      let error = { ...errors };
      error[`${name}`] = "";
      setFormvalue(Formvalue);
      setErrors(error);
    } catch (err) {
      console.log(err, "handleChange");
    }
  };


  const handleSocialLinks = async (e, index) => {
    try {
      const { name, value } = e.target;
      let arr = [...formvalue.testimonial];
      console.log(formvalue.testimonial, 'formvalue.testimonial', index)
      let val = arr[index] ? arr[index] : {};
      if (name == "image") {
        val[`${name}`] = e.target.files[0];
      } else {
        val[`${name}`] = value;
      }
      arr[index] = val;
      console.log("🚀 ~ handleSocialLinks ~ arr[index]:", arr[index])
      let Formvalue = { ...formvalue, ["testimonial"]: arr };
      setFormvalue(Formvalue);
      // setErrors(validation(Formvalue));
    } catch (err) {
      console.log(err, "handleHighlights");
    }
  };







  const validation = (value) => {
    console.log("🚀 ~ validation ~ value:", value)
    try {
      let error = { ...errors };
      if (isEmpty(value.identifier)) {
        error["identifier"] = "Field is required";
      } else {
        error["identifier"] = "";
      }
      if (isEmpty(value.heading)) {
        error["heading"] = "Field is required";
      } else {
        error["heading"] = "";
      }
      // if (isEmpty(value.subHeading)) {
      //   error["subHeading"] = "Field is required";
      // } else {
      //   error["subHeading"] = "";
      // }
      if (isEmpty(value.content)) {
        error["content"] = "Field is required";
      } else {
        error["content"] = "";
      }
      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {

      console.log(formvalue, "formvalue")

      if (formvalue.identifier != 'testimonials') {
        let oj = {
          _id: record._id,
          identifier: formvalue.identifier,
          heading: formvalue.heading,
          subHeading: formvalue.subHeading,
          content: formvalue.content,
          testimonial: formvalue.testimonial
        }
        let { status, message, result } = await EditCMS(oj);

        if (status == "success") {
          toast.success(message);
          handleClose();
          getCMSData()
        } else {
          toast.error(message);
          handleClose();
          getCMSData()
        }
        handleClose();

      }
      else {
        const formData = new FormData();
        formData.append("_id", record._id);
        formData.append("identifier", formvalue.identifier);
        formData.append("heading", formvalue.heading);
        formData.append("subHeading", formvalue.subHeading);
        formData.append("content", formvalue.content);

        for (let i = 0; i < formvalue.testimonial.length; i++) {
          formData.append("images", formvalue.testimonial[i].image);
        }
        formData.append("testimonial", JSON.stringify(formvalue.testimonial));

        let { status, message, result } = await EditCMS(formData);

        if (status == "success") {
          toast.success(message);
          handleClose();
          getCMSData()
        } else {
          toast.error(message);
          handleClose();
          getCMSData()
        }
        handleClose();





      }









    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };


  return (
    <>
      <Modal
        centered
        className="cmn_modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="cmn_modal_header d-flex justify-content-between align-items-center">
            <p className="cmn_modal_title">Edit Cms</p>
            <button
              className="cmn_modal_closer rounded-5"
              onClick={() => {
                handleClose();
              }}
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="mt-4">
            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Identifier</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Enter Identifier"
                  className="rp_singleInput flex-grow-1"
                  name="identifier"
                  value={formvalue?.identifier}
                  disabled
                />
              </div>
            </div>

            {
              formvalue?.heading != "" ?
                <div className="rp_singleinput_holder mb-3">
                  <p className="rp_label mb-2">Heading</p>
                  <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                    <input
                      type="text"
                      placeholder="Enter Heading"
                      className="rp_singleInput flex-grow-1"
                      name="heading"
                      onChange={handleChange}
                      value={formvalue?.heading}
                    />
                  </div>
                </div>

                : ""
            }

            {
              formvalue?.subHeading != "" ?
                <div className="rp_singleinput_holder mb-3">
                  <p className="rp_label mb-2">Sub Heading</p>
                  <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                    <input
                      type="text"
                      placeholder="Enter Sub Heading"
                      className="rp_singleInput flex-grow-1"
                      name="subHeading"
                      onChange={handleChange}
                      value={formvalue?.subHeading}

                    />
                  </div>
                </div>
                : ""
            }

            {
              formvalue?.content != "" ?
                <div className="rp_singleinput_holder mb-3">
                  <p className="rp_label mb-2">Content</p>
                  <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                    <textarea
                      placeholder="Enter Content"
                      className="rp_singleInput flex-grow-1"
                      rows="4"
                      name="content"
                      onChange={handleChange}
                      value={formvalue?.content}
                    />
                  </div>
                </div>

                : ""
            }



            {
              formvalue?.identifier == "testimonials" ?

                <>

                  {[...Array(count)].map((item, index) => {
                    let i = index;
                    return (
                      <>
                        <div className="rp_singleinput_holder mb-3">
                          <p className="rp_label mb-2">Name</p>
                          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                            <input
                              placeholder="Enter Content"
                              className="rp_singleInput flex-grow-1"
                              rows="4"
                              name="name"
                              onChange={(e) => { handleSocialLinks(e, index) }}
                              value={formvalue?.testimonial[index]?.name}
                            />
                          </div>
                        </div>


                        <div className="rp_singleinput_holder mb-3">
                          <p className="rp_label mb-2">Content Card</p>
                          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                            <textarea
                              placeholder="Enter Content"
                              className="rp_singleInput flex-grow-1"
                              rows="4"
                              name="content"
                              onChange={(e) => { handleSocialLinks(e, index) }}
                              value={formvalue?.testimonial[index]?.content}
                            />
                          </div>
                        </div>


                        <div className="rp_singleinput_holder mb-3">
                          <p className="rp_label mb-2">Social Logo</p>
                          <label
                            for={`file-upload${i}`}
                            className="custom-file-upload mt-3">
                            Custom Upload
                          </label>
                          <input
                            id={`file-upload${i}`}
                            type="file"
                            name="image"
                            className="hide_input"
                            onChange={(e) => {
                              handleSocialLinks(e, i);
                            }}
                          />
                        </div>


                        <div className="rp_singleinput_holder mb-3">
                          <img
                            className="img-fluid cmn__siteLogo"
                            src={
                              // API_URL +
                              // "/public/images/" +
                              // formvalue?.socialLinks[index]?.image

                              formvalue?.testimonial?.length > 0 &&
                                typeof formvalue?.testimonial[index]?.image ==
                                "string"
                                ? API_URL +
                                "/public/images/" +
                                formvalue?.testimonial[index]?.image
                                : typeof formvalue?.testimonial[index]
                                  ?.image == "undefined"
                                  ? ""
                                  : URL.createObjectURL(
                                    formvalue?.testimonial[index]?.image
                                  )
                            }
                          />
                        </div>

                      </>
                    );
                  })}

                  <Row className="align-items-center">
                    <Col lg={5} className="mb-4">
                      <div className="rp_singleinput_holder">
                        <button
                          className="orange_small_primary mt-4"
                          onClick={() => {
                            setCount(count + 1);
                          }}
                        >
                          Add
                        </button>
                        <button
                          className="orange_small_secondary mt-4 ms-3"
                          disabled={count == 1 ? "disabled" : ""}
                          onClick={() => {
                            setCount(count - 1);
                          }}>
                          Delete
                        </button>
                      </div>
                    </Col>
                  </Row>

                </>



                : ""
            }



            <button className="orange_small_primary mt-3"
              onClick={() => {
                handleSubmit();
              }}
            >Submit</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditCmsModal;
